import { apiClient } from 'v4/core/apiClient';
import { createReportTemplatesApi } from './reportTemplates.api.http';

export const myReportTemplatesApi = createReportTemplatesApi(apiClient);
